/**
 * 리뉴얼 디자인에서 사용하는 이미지 모음.
 * design_handoff_brit_homepage/assets → src/assets/images/renewal 로 복사한 파일들입니다.
 */
import LogoFooter from '../../assets/images/renewal/logo_footer.png';
import LogoHeader from '../../assets/images/renewal/logo_header.png';

import ClientCosmo from '../../assets/images/renewal/c_cosmo.png';
import ClientDki from '../../assets/images/renewal/c_dki.png';
import ClientGs from '../../assets/images/renewal/c_gs.svg';
import ClientHankuk from '../../assets/images/renewal/c_hankuk.png';
import ClientHanwhalife from '../../assets/images/renewal/c_hanwhalife.png';
import ClientHyundaiwia from '../../assets/images/renewal/c_hyundaiwia.svg';
import ClientKomsco from '../../assets/images/renewal/c_komsco.png';
import ClientKt from '../../assets/images/renewal/c_kt.png';
import ClientLg from '../../assets/images/renewal/c_lg.svg';
import ClientLgcns from '../../assets/images/renewal/c_lgcns.png';
import ClientLgelec from '../../assets/images/renewal/c_lgelec.png';
import ClientNiie from '../../assets/images/renewal/c_niie.png';
import ClientNsm from '../../assets/images/renewal/c_nsm.png';
import ClientSalim from '../../assets/images/renewal/c_salim.svg';
import ClientSamsung from '../../assets/images/renewal/c_samsung.svg';
import ClientUnies from '../../assets/images/renewal/c_unies.png';
import ClientWoongjin from '../../assets/images/renewal/c_woongjin.png';

import PfFod from '../../assets/images/renewal/pf_fod.jpg';
import PfGsgev from '../../assets/images/renewal/pf_gsgev.jpg';
import PfHyundaiwia from '../../assets/images/renewal/pf_hyundaiwia.jpg';
import PfKtrbrain from '../../assets/images/renewal/pf_ktrbrain.jpg';
import PfLges from '../../assets/images/renewal/pf_lges.jpg';
import PfScience from '../../assets/images/renewal/pf_science.jpg';
import PfSmarthome from '../../assets/images/renewal/pf_smarthome.jpg';
import PfUnies from '../../assets/images/renewal/pf_unies.jpg';

export const logos = {
  header: LogoHeader,
  footer: LogoFooter,
};

export const portfolioImages = {
  fod: PfFod,
  lges: PfLges,
  hyundaiwia: PfHyundaiwia,
  science: PfScience,
  ktrbrain: PfKtrbrain,
  gsgev: PfGsgev,
  unies: PfUnies,
  smarthome: PfSmarthome,
};

export const clientLogos = {
  lg: ClientLg,
  lgelec: ClientLgelec,
  lgcns: ClientLgcns,
  samsung: ClientSamsung,
  gs: ClientGs,
  hyundaiwia: ClientHyundaiwia,
  kt: ClientKt,
  komsco: ClientKomsco,
  hanwhalife: ClientHanwhalife,
  niie: ClientNiie,
  nsm: ClientNsm,
  salim: ClientSalim,
  unies: ClientUnies,
  woongjin: ClientWoongjin,
  dki: ClientDki,
  hankuk: ClientHankuk,
  cosmo: ClientCosmo,
};
